<template>
  <div class="pageloader">
    <img src="/static/img/AxisLoader.gif" alt="Loading">
  </div>
  <div v-if="!isAuthenticated" class="text-center">
    <img src="/static/img/simnach_logo.png" height="300" width="700" class="rounded" alt="...">
  </div>
  <header v-if="isAuthenticated">
    <div style="height: 70px">
      <div class="login-logo"><img src="/static/img/axis_logo.png" alt="Axis Logo"></div>
      <nav class="navbar fixed-top navbar-toggleable-md navbar-expand-lg double-nav" style="height: 60px;">
        <ul class="nav navbar-nav nav-flex-icons mr-auto" style="margin-left: 200px;">
          <li class="nav-item">
            <a class="nav-link" href="#" @click.prevent="goBack"><i class="fa fa-arrow-left pl-2"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/home"><i class="fa fa-home"></i></a>
          </li>
        </ul>
        <div class="breadcrumb-dn mr-auto"></div>
        <ul class="nav navbar-nav nav-flex-icons ml-auto">
          <template v-for="role in userRoles" :key="role.id">
            <template v-for="menu in role.menus" :key="menu.id">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" :id="'dropdown' + menu.role_id" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  {{ menu.name }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="'dropdown' + menu.role_id">
                  <a v-for="submenu in menu.submenus" :key="submenu.id" class="dropdown-item"
                    @click="navigateTo(submenu.access_path)" >{{ submenu.name }}</a>
                </div>
              </li>
            </template>
          </template>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false" style="padding-bottom: 0px!important;">
              <i class="fa fa-user"></i> {{ userName }}
            </a>
            <div class="dropdown-menu dropdown-menu-right"
                 aria-labelledby="navbarDropdownMenuLink"
                 style="min-width: 280px; padding: 4px 16px; font-size: 0.8em; line-height: 1.6; white-space: nowrap;">
              <div style="padding: 4px 16px; font-size: 1em; line-height: 1.6;">
                <div>
                  <label style="font-weight: bold; margin-right: 4px;">Last Login:</label>
                  <span>{{ lastLoginTime }}</span>
                </div>
                <div>
                  <label style="font-weight: bold; margin-right: 4px;">Unsuccessful Login:</label>
                  <span>{{ unsuccessfulLoginTime }}</span>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger" href="#" @click.prevent="signOut">
                <i class="fa fa-sign-out-alt"></i> Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>


<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Client } from './api';

@Options({})
export default class HeaderComponent extends Vue {
  // Sample data to mimic Go template functions
  isAuthenticated = !!localStorage.getItem('session-token');
  userRoles = [
    {
      id: 1,
      menus: [
        {
          role_id: 1,
          name: 'Menu 1',
          submenus: [
            { id: 1, name: 'Submenu 1', access_path: '/path1' },
            { id: 2, name: 'Submenu 2', access_path: '/path2' },
          ],
        },
        {
          role_id: 2,
          name: 'Menu 2',
          submenus: [
            { id: 3, name: 'Submenu 3', access_path: '/path3' },
            { id: 4, name: 'Submenu 4', access_path: '/path4' },
          ],
        },
      ],
    },
  ];

  mounted() {

    this.userRoles = []
    console.log("mounted")

    const username = localStorage.getItem('user-name')
    const lastLoginTime =localStorage.getItem('user-lastLoginTime')
    const unsuccessfulLoginTime =localStorage.getItem('user-unsuccessfulLoginTime')

    if (this.isAuthenticated && username) {
      this.loadMenu()
      this.userName = username
      this.lastLoginTime = lastLoginTime
      this.unsuccessfulLoginTime=unsuccessfulLoginTime
    }
  }

  navigateTo(url: string) {
    if (url == '/api/v1/operation/report/account_close_report') {
      this.downloadAccountCloseReport()
    } else if (url == '/api/v1/operation/report/mandate_registration_summery_report') {
      this.downloadMandateRegSummeryReport()
    } else if (url == '/api/v1/operation/report/missingbranchreport') {
      this.downloadMissingBranchReport()
    } else if (url == '/api/v1/operation/report/parentchildreport') {
      this.downloadParentChildReport()
    } else if (url == '/api/v1/operation/report/mandate_cancellation_report') {
      this.downloadMandateCancellationReport()
    } else if (url == '/api/v1/operation/report/hold_report') {
      this.downloadHoldReport()
    } else {
      if (this.$route.path == url){
        window.location = url as any
        return
      }
      this.$router.push(url)
    }
  }

  async downloadAccountCloseReport() {
    try {
      const resp = await Client.get('/api_backend/v1/operation/report/account_close_report_api', {
        responseType: 'blob',
      });
      const blob = new Blob([resp.data])
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Set the filename (optional but recommended)
      link.setAttribute('download', "account_close_report.csv");

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the link after the download is triggered
      document.body.removeChild(link);

    } catch (e: any) {
      this.$toast.open({
        message: `Error downloading file: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async downloadMandateRegSummeryReport() {
    try {
      const formData = new FormData();
    formData.append("module", "MandateRegistrationSummeryReport");

     await Client.post(`/api_backend/v1/operation/report/generate_report`,formData, { headers: { "Content-Type": "multipart/form-data" },
    });
    this.$toast.open({
        message: "Download initiated! Visit High Volume Records to get your file",
        type: 'success',
        position: 'top-right',
        duration: 5000,
      });

    } catch (e: any) {
      this.$toast.open({
        message: `Error downloading file: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async downloadMissingBranchReport() {
    try {
      const resp = await Client.get('/api_backend/v1/operation/report/missingbranchreport_api', {
        responseType: 'blob',
      });
      const blob = new Blob([resp.data])
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Set the filename (optional but recommended)
      link.setAttribute('download', "Missing_Branch_Report.csv");

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the link after the download is triggered
      document.body.removeChild(link);

    } catch (e: any) {
      this.$toast.open({
        message: `Error downloading file: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async downloadMandateCancellationReport() {
    try {
      const resp = await Client.get('/api_backend/v1/operation/report/mandate_cancellation_report_api', {
        responseType: 'blob',
      });
      const blob = new Blob([resp.data])
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Set the filename (optional but recommended)
      link.setAttribute('download', "Mandate_cancellation_report.csv");

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the link after the download is triggered
      document.body.removeChild(link);

    } catch (e: any) {
      this.$toast.open({
        message: `Error downloading file: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async downloadParentChildReport() {
    try {
      const resp = await Client.get('/api_backend/v1/operation/report/parentchildreport_api', {
        responseType: 'blob',
      });
      const blob = new Blob([resp.data])
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Set the filename (optional but recommended)
      link.setAttribute('download', "Parent_Child_Report.csv");

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the link after the download is triggered
      document.body.removeChild(link);

    } catch (e: any) {
      this.$toast.open({
        message: `Error downloading file : ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async downloadHoldReport() {
    try {
      const resp = await Client.get('/api_backend/v1/operation/report/hold_report_api', {
        responseType: 'blob',
      });
      const blob = new Blob([resp.data])
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Set the filename (optional but recommended)
      link.setAttribute('download', "Hold_report.csv");

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the link after the download is triggered
      document.body.removeChild(link);

    } catch (e: any) {
      this.$toast.open({
        message: `Error downloading file: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async loadMenu() {

    try {

      const menuReq = await Client.get("/home_api")
      this.userRoles = menuReq.data

      if (!this.userRoles.length)
        await this.signOut()

    } catch (e: any) {
      console.error(e)
      this.$toast.open({
        message: `Error fetching menu. Please refresh the page: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
        // all of other options may go here
      });
    }
  }

  userName: any = "Default"; // Placeholder for GetUserName function
  lastLoginTime: any = "0000-00-00T00:00:00Z";
  unsuccessfulLoginTime: any = "0000-00-00T00:00:00Z";

  goBack() {
    window.history.back();
  }

  async signOut() {

    try {

      await Client.get("/signoutapi")

      localStorage.clear()
      window.location = "/login" as any
    } catch (e: any) {

      this.$toast.open({
        message: `Error signing out: ${e?.response?.data?.err}`,
        type: 'error',
        position: 'top-right',
        duration: 3000,
        // all of other options may go here
      });
    }
  }
}

</script>